import { combineReducers } from 'redux';

import auth from './auth/authReducer';
import routers from './routers/routersReducer';
import dashboard from './dashboard/dashboardReducer';
import users from 'screens/Accounts/store/reducer'; 

export default combineReducers({ auth, routers, dashboard, users });
